<script lang="ts" module>
  import { get, writable, type Writable } from 'svelte/store';

  export const ControlConfig = writable(null);

  type ToolTipState = {
    left: number;
    markup: string;
    show: boolean;
    top: number;
  };

  interface ToolTipStore extends Writable<ToolTipState> {
    hide: () => void;
    show: (x: number, y: number, markup: string) => void;
  }

  const store = writable<ToolTipState>({
    top: 0,
    left: 0,
    markup: '',
    show: false
  });
  const { set, subscribe, update } = store;

  export const toolTipStore = (): ToolTipStore => {
    return {
      set,
      subscribe,
      update,
      hide: () => {
        const state = get(store);
        const toolTip = { ...state, markup: '', show: false };

        set(toolTip);
      },
      show: (x, y, markup) => {
        const toolTip = { show: true, markup, top: y, left: x };

        set(toolTip);
      }
    };
  };
</script>

<script lang="ts">
  import { cx } from '@emotion/css';
  import { ResponsiveVars } from '@twist/core';
  import { toFluidVarInput } from '$lib/utils/fluidity';

  const responsiveVars = new ResponsiveVars()
    .addFluid('spacer-2', toFluidVarInput(9, 8))
    .addFluid('spacer-3', toFluidVarInput(12, 12))
    .toCSS();
</script>

{#if $store.markup}
  <div
    class={cx(responsiveVars, 'dataviz-tooltip')}
    class:show={$store.show}
    style="--top: {$store.top}px; --left: {$store.left}px;"
  >
    {@html $store.markup}
  </div>
{/if}

<style lang="scss">
  .dataviz-tooltip {
    position: fixed;
    background-color: white;
    color: black;
    border-radius: 5px;
    box-shadow: 8px 8px 24px 0px rgba(0, 0, 0, 0.5);
    transition: opacity 0.2s ease-in;
    padding: var(--spacer-3);
    pointer-events: none;
    top: var(--top);
    left: var(--left);
    opacity: 0;
    z-index: 9999;

    &.show {
      opacity: 1;
    }

    :global(p) {
      margin-bottom: var(--spacer-2);
      font-family: var(--twist-font-family-pp-neue-machina);
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 100%;
      text-transform: capitalize;

      &:last-of-type {
        margin-bottom: 0px;
      }
    }

    :global(p.category) {
      margin-bottom: var(--spacer-3);
      font-family: var(--twist-font-family-pilat-condensed);
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: 110%;
    }
  }
</style>
